import actionTypes from '../actionTypes';

export function requestOptMission(missionId: number) {
    return {
        type: actionTypes.OPT_TO_MISSION_REQUEST,
        missionId,
    };
}

export function failOptMission(e: any) {
    return {
        type: actionTypes.OPT_TO_MISSION_FAILURE,
        exception: e,
    };
}
